// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__24c4J","footer":"ModalCreateQualiphyProcedure_footer__22TI7","additionData":"ModalCreateQualiphyProcedure_additionData__LC4jL"};